var helperGetDateTime = require('./helperGetDateTime')
var helperGetYMD = require('./helperGetYMD')

function helperGetYMDTime (date) {
  return helperGetDateTime(helperGetYMD(date))
}

module.exports = helperGetYMDTime



//////////////////
// WEBPACK FOOTER
// ./~/.store/xe-utils@3.7.9/~/xe-utils/helperGetYMDTime.js
// module id = 1168
// module chunks = 75